import { Component } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { TopbarService } from 'src/app/core/topbar/topbar.service';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from '../../login/login.service';
import { firstValueFrom } from 'rxjs';
import { Trade } from '../../common/_types/trade';
import { TradesService } from '../../common/_services/trades.service';

@Component({
    selector: 'app-trades-detail',
    templateUrl: './trades-detail.component.html',
    styleUrls: ['./trades-detail.component.scss'],
    standalone: false
})
export class TradesDetailComponent {
  public tradeFormGroup!: RxFormGroup;
  public trade: any = new Trade();
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;

  constructor(
    private tradesService: TradesService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private router: Router,
    private topbarService: TopbarService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private loginService: LoginService,
  ) {
    this.tradeFormGroup = this.formBuilder.formGroup<Trade>(this.trade) as RxFormGroup;
  }

  async ngOnInit() {
    this.topbarService.setTitle("Detalle de ramo");
    this.topbarService.addBreadcrumb("Ramos", "/trades");
    let id = this.route.snapshot.params['id'];
    if (id != null && id != '0') {
      await this.loadTrade(id);
    }

    this.allowWrite = this.loginService.hasPermission("TRADES.WRITE");
    this.allowDelete = this.loginService.hasPermission("TRADES.DELETE");
  }

  async loadTrade(id: string) {
    this.trade = await firstValueFrom(this.tradesService.get(id));
    this.tradeFormGroup.patchValue(this.trade);
  }

  async save() {
    let valid = this.formValidationService.validateForm(this.tradeFormGroup);
    if (valid) {
      this.trade = Object.assign(this.trade, this.tradeFormGroup.value);
      let trade = await firstValueFrom(this.tradesService.save(this.trade));
      this.messageService.add({ closable: true, severity: 'success', summary: "Oficio guardado correctamente." });
      this.router.navigate(['trades']);
    } else {
      this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
    }
  }

  async delete() {
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el oficio?",
      header: "Eliminar oficio",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.tradesService.delete(this.trade.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Oficio eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: (error: any) => {
        this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
      }
    });
  }

  cancel() {
    this.router.navigate(['trades']);
  }
}
